module.exports = __webpack_public_path__ + "img/easycob.03e8a672.png";